import { Badge } from '@/components/ui/badge';
import PaginatedTable from '@/components/ui/paginated';
import { TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { getTransactions } from '@/services/api/transactions';
import { format } from 'date-fns';
import React from 'react';

export interface Props {
  userId: string;
}

const UserTransactionsTab: React.FC<Props> = ({ userId }) => {
  return (
    <div className="space-y-3">
      <PaginatedTable
        source={(page, size) => getTransactions(userId, page, size)}
        renderHeader={() => (
          <TableHeader>
            <TableRow>
              <TableHead className="w-[100px]">Status</TableHead>
              <TableHead className="w-[100px]">ID</TableHead>
              <TableHead className="w-[120px]">Amount</TableHead>
              <TableHead className="w-[100px]">Purchase date</TableHead>
            </TableRow>
          </TableHeader>
        )}
      >
        {(transactions) => (
          <TableBody>
            {transactions.map((transaction) => (
              <TableRow key={transaction.id}>
                <TableCell>
                  <PaidTag status={transaction.payment.status} />
                </TableCell>
                <TableCell>{transaction.id}</TableCell>
                <TableCell>{transaction.totalPrice} RON</TableCell>
                <TableCell>{format(transaction.createdAt, 'PP')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </PaginatedTable>
    </div>
  );
};

function PaidTag({ status }) {
  return <Badge variant={status == 'PAID' ? 'success' : 'destructive'}>{status}</Badge>;
}

export default UserTransactionsTab;
